import {InputProps, MenuItem, TextField, TextFieldProps} from '@mui/material';

import {COMMUNICATION_NODE_STATUSES} from '../../constants/status';

export const CommtracNodeStatusSelect: React.FC<TextFieldProps> = (props) => {
  const handleChange: InputProps['onChange'] = (event: any) => {
    props.onChange?.(event.target.value);
  };

  return (
    <TextField
      {...props}
      label={props.label ?? 'Status'}
      value={props.value ?? 'all'}
      select
      SelectProps={{
        MenuProps: {
          sx: {maxHeight: '300px'},
        },
      }}
      onChange={handleChange}
    >
      {COMMUNICATION_NODE_STATUSES.map((i) => (
        <MenuItem key={i.key} value={i.key}>
          {i.name}
        </MenuItem>
      ))}
    </TextField>
  );
};
